import { render, staticRenderFns } from "./CampoCredibancoTramas.vue?vue&type=template&id=44b096f8&scoped=true"
import script from "./CampoCredibancoTramas.vue?vue&type=script&lang=js"
export * from "./CampoCredibancoTramas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b096f8",
  null
  
)

export default component.exports